import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../common-components/NoDataFound";
import { SettingIcon } from "../../assets/Icon/headerCicon";
import {
  disconnectStripe,
  getCustomInvoices,
  getInvoiceList,
} from "../../stores/clients";
import { useDispatch } from "react-redux";
import { setToast } from "../../stores/toast/toastslice";
import {
  Box,
  useTheme,
  useMediaQuery,
  Button,
  TableCell,
  TableRow,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import {
  ModalWrapper,
  CloseButton,
  CloseButtonWrapper,
} from "../style/modalStyle";
import { ModalTop, ModalBottom } from "../../assets/Icon/ModalIcon";
import { CrossIcon } from "../../assets/Icon/ModalIcon";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CircularProgress from "@mui/material/CircularProgress";
import ListLoadingNew from "../common-components/ListLoadingNew";

const NoInvoicePage = ({ setPage }: { setPage: () => void }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [disconnectAnchorEl, setDisconnectAnchorEl] =
    useState<null | HTMLElement>(null);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const [stripeConnecting, setStripeConnecting] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disconnectBtnLoading, setDisconnectBtnLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleStripeDisconnect = async () => {
    setDisconnectBtnLoading(true);
    try {
      const response = await dispatch<any>(disconnectStripe()).unwrap();
      if (response?.code === 200) {
        dispatch<any>(
          setToast({
            message: response?.message || "Stripe account disconnected!",
            type: "success",
            title: "Success",
            onClose: () => {},
          })
        );
        navigate("/tools/invoices");
        dispatch<any>(
          getInvoiceList({
            offset: 0,
            search: "",
            filter_by: undefined,
          })
        );
      }
      if (response?.code === 400 || response?.code === 422) {
        dispatch<any>(
          setToast({
            message:
              response?.message || "Failed to disconnect stripe account!",
            type: "error",
            title: "Error",
            onClose: () => {},
          })
        );
      }
      setDisconnectModalOpen(false);
    } catch (e) {
      setDisconnectModalOpen(false);
    } finally {
      setDisconnectBtnLoading(false);
    }
  };

  useEffect(() => {
    const response = dispatch<any>(
      getInvoiceList({
        offset: 0,
        search: "",
        filter_by: undefined,
      })
    ).then((res: any) => {
      dispatch<any>(
        getCustomInvoices({
          offset: 0,
          limit: 10,
          search: "",
        })
      ).then((result: any) => {
        if (result?.payload?.data?.length) {
          navigate("/tools/invoices/setup");
        }
      });
    });
  }, [dispatch]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 5000);
    return () => clearTimeout(timeout);
  }, []);

  if (loading) {
    return <ListLoadingNew />;
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 5,
            position: "relative",
            marginTop: isMobile ? 7 : 0,
          }}
        >
          <div
            style={{
              background: "white",
              border: "1px solid #EAF1FA",
              width: "187px",
              height: "46px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "10px",
              position: "relative",
              gap: 5,
            }}
          >
            <CheckCircleRoundedIcon
              style={{
                color: "#3DC826",
                width: "20px",
              }}
            />
            <span
              style={{
                textAlign: "center",
                fontWeight: 500,
                fontSize: "14px",
                color: "#3DC826",
              }}
            >
              Stripe Connected
            </span>
          </div>
          <IconButton
            style={{
              backgroundColor: "white",
              height: "46px",
              padding: "10px",
              border: "1px solid #EAF1FA",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "background-color 0.2s",
              marginLeft: 8,
            }}
            onClick={(e) => setDisconnectAnchorEl(e.currentTarget)}
          >
            <KeyboardArrowUpIcon
              style={{
                color: "#6C6F71",
                transform: Boolean(disconnectAnchorEl)
                  ? "rotate(180deg)"
                  : "none",
                transition: "transform 0.2s",
              }}
            />
          </IconButton>
          <Menu
            anchorEl={disconnectAnchorEl}
            open={Boolean(disconnectAnchorEl)}
            onClose={() => setDisconnectAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{
              sx: {
                backgroundColor: "white",
                boxShadow: "0px 5px 8px rgba(0,0,0,0.08)",
                borderRadius: "8px",
                width: "230px",
                marginTop: 1,
                marginLeft: -3,
              },
            }}
            MenuListProps={{
              disablePadding: true,
            }}
          >
            <MenuItem
              onClick={() => {
                setDisconnectAnchorEl(null);
                setDisconnectModalOpen(true);
              }}
              disableRipple
              sx={{
                fontWeight: 500,
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                cursor: "pointer",
                padding: "16px 16px",
              }}
            >
              Disconnect Stripe
            </MenuItem>
          </Menu>
        </div>
      </div>
      <div style={{ marginTop: 10 }}>
        <NoDataFound
          title="No Invoice Created Yet"
          subTitle="Start creating invoices to bill your customers, track payments, and manage your finances easily."
          buttonTitle="Create Invoice"
          handleData={() => navigate("/tools/invoices/customerInfo")}
          status={true}
        />
      </div>
      <Modal
        open={disconnectModalOpen}
        onClose={() => setDisconnectModalOpen(false)}
      >
        <ModalWrapper
          sx={{
            width: isMobile ? "350px" : "500px",
            p: 0,
            height: isMobile ? "250px" : "270px",
            backgroundImage: "none",
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            outline: "none",
          }}
        >
          {/* Top right decoration */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <ModalTop />
          </div>
          {/* Bottom left decoration */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              left: 0,
              zIndex: 1,
            }}
          >
            <ModalBottom />
          </div>
          {/* Ensure close button is above decorations */}
          <CloseButtonWrapper
            sx={{ zIndex: 10, position: "relative", marginTop: 1 }}
          >
            <CloseButton onClick={() => setDisconnectModalOpen(false)}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Box sx={{ p: 4, pt: 0 }}>
            {/* Trash icon with red bg */}
            {/* <Box
              sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}
            >
              <Box
                sx={{
                  background: "#F20F0014",
                  borderRadius: "50%",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TrashIconForPopup />
              </Box>
            </Box> */}
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? "20px" : "24px",
                color: "#01060B",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: 10,
              }}
            >
              Disconnect Stripe
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "300px",
                textAlign: "center",
                lineHeight: "24px",
                margin: "0 auto",
                fontSize: isMobile ? "12px" : "16px",
                color: "#6C6F71",
                fontWeight: 500,
                fontFamily: "Plus Jakarta Sans",
              }}
            >
              Are you sure you want to disconnect your stripe?
            </div>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 3,
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  border: "2px solid #2977CC",
                  borderRadius: "8px",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#2977CC",
                  opacity: disconnectBtnLoading ? 0.7 : 1,
                }}
                onClick={() => setDisconnectModalOpen(false)}
                disabled={disconnectBtnLoading}
              >
                Close
              </Button>
              <Button
                sx={{
                  background: disconnectBtnLoading
                    ? "#BDBDBD"
                    : "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  opacity: disconnectBtnLoading ? 0.7 : 1,
                }}
                onClick={handleStripeDisconnect}
                disabled={disconnectBtnLoading}
              >
                {disconnectBtnLoading ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  </span>
                ) : (
                  "Yes"
                )}
              </Button>
            </Box>
          </Box>
        </ModalWrapper>
      </Modal>
    </div>
  );
};

export default NoInvoicePage;
